import DataStore from "./DataStore";
import UIStore from "./UIStore";
import CurrentUserStore from "./CurrentUserStore";

class RootStore {
  constructor() {
    this.data = new DataStore();
    this.ui = new UIStore(this);

    this.currentUser = new CurrentUserStore(this);

    this.ui.initializeHandlers();
  }
}

export default RootStore;



// WEBPACK FOOTER //
// ./src/Stores/index.js